import type React from 'react';

import { getToastStore } from '@/stores';
import type { ToastData, ToastType } from '@/stores';

type ToastOptions = Omit<ToastData, 'id' | 'type' | 'message' | 'render'>;
type CustomRender = (props: {
    toast: ToastData;
    onClose: () => void;
}) => React.ReactNode;

function createToast(
    message: string,
    type: ToastType,
    opts?: ToastOptions,
): string {
    return getToastStore().add({ message, type, ...opts });
}

function toast(message: string, opts?: ToastOptions & { type?: ToastType }) {
    return createToast(message, opts?.type ?? 'info', opts);
}

toast.success = (message: string, opts?: ToastOptions) =>
    createToast(message, 'success', opts);

toast.error = (message: string, opts?: ToastOptions) =>
    createToast(message, 'error', opts);

toast.warning = (message: string, opts?: ToastOptions) =>
    createToast(message, 'warning', opts);

toast.info = (message: string, opts?: ToastOptions) =>
    createToast(message, 'info', opts);

toast.custom = (
    render: CustomRender,
    opts?: ToastOptions & { type?: ToastType },
) =>
    getToastStore().add({
        message: '',
        type: opts?.type ?? 'info',
        render,
        ...opts,
    });

toast.dismiss = (id: string) => getToastStore().dismiss(id);

toast.clear = () => getToastStore().clear();

export { toast };
